<template>
  <div class="trtc-container">
    <!-- 本地视频 -->
    <div id="localVideo"></div>
    

    <div class="controls">
      <button @click="startCall">开始通话</button>
    </div>
  </div>
</template>
<script>
import TRTC from 'trtc-sdk-v5';

export default {
  name: 'TRTCVideo',
  data() {
    return {
      trtcClient: null,
      localStream: null,
      remoteStream: null,
      isConnected: false,
      isMicOn: true,
      isCameraOn: true,
      // ⚠️ 生产环境必须从后端获取！
      config: {
        sdkAppId: 1600107150, // 替换为你的 SDKAppID
        userId: `user_${Math.random().toString(36).substr(2)}`, // 随机用户ID
        roomId: 12345, // 房间号
        userSig: 'eJwtzF8LgjAUBfDvstdCrqPrQughC8IoiBKkpxg662KONf9kRN89sz2e3zmcN0t2J69TloWMe8CmY6Zc6YYKGrmSpC8cOLqyzktpDOUs9AMAH4SP8G9Ub8iqwRGRAzhtqPqZwHkwLIXTmq7D98GkJdzFBrNXxIt9*uiL2J6PTzkpl0nW6VUM6zZqZ9tbvGCfL76QMkg_', // 动态生成（这里仅用于测试）
      }
    };
  },
  methods: {
    // 生成测试 userSig（⚠️ 仅限开发，生产环境必须用后端 API）
    generateTestUserSig(userId) {
      const crypto = window.crypto || window.msCrypto;
      const expireTime = 3600 * 24; // 1天有效期
      const timestamp = Math.floor(Date.now() / 1000);
      
      // ⚠️ 注意：这里只是模拟，生产环境必须用后端计算！
      return {
        userSig: 'mock-sig-for-test-only', // 替换为真实签名
        expireTime: timestamp + expireTime,
      };
    },

    // 初始化 TRTC
    async initTRTC() {
      this.trtcClient = TRTC.create();
      const sdkAppId =  this.config.sdkAppId
      const userId = `main_2025`; // 随机用户ID
      const userSig =  this.config.userSig
      await this.trtcClient.enterRoom({ roomId: 8888, sdkAppId, userId, userSig });
    },

    // 开始通话
    async startCall() {
      try {
        await this.initTRTC();
        await this.trtcClient.startLocalVideo({
          view: document.getElementById('localVideo'), // 在 DOM 中的 elementId 为 localVideo 的标签上预览视频。
        });
        await this.trtcClient.startLocalAudio();
        // // 1. 加入房间
        // await this.trtcClient.join({
        //   sdkAppId: this.config.sdkAppId,
        //   userId: this.config.userId,
        //   roomId: this.config.roomId,
        //   userSig: this.config.userSig,
        // });

        // // 2. 创建本地流
        // this.localStream = this.trtcClient.createStream({
        //   audio: this.isMicOn,
        //   video: this.isCameraOn,
        //   userId: this.config.userId,
        // });
        // await this.localStream.initialize();

        // // 3. 播放本地视频
        // this.localStream.play(this.$refs.localVideo);

        // // 4. 发布本地流
        // await this.trtcClient.publish(this.localStream);

        // this.isConnected = true;
      } catch (error) {
        console.error('TRTC 错误:', error);
        // alert(`通话失败: ${error.message}`);
      }
    },

    // 结束通话
    async stopCall() {
      if (this.localStream) {
        this.localStream.close();
      }
      if (this.trtcClient) {
        await this.trtcClient.leave();
      }
      this.isConnected = false;
    },

    // 切换麦克风
    toggleMic() {
      if (this.localStream) {
        this.isMicOn = !this.isMicOn;
        this.localStream.muteAudio(!this.isMicOn);
      }
    },

    // 切换摄像头
    toggleCamera() {
      if (this.localStream) {
        this.isCameraOn = !this.isCameraOn;
        this.localStream.muteVideo(!this.isCameraOn);
      }
    },

    // 处理远端流
    handleStreamAdded(event) {
      const remoteStream = event.stream;
      this.trtcClient.subscribe(remoteStream)
        .then(() => {
          this.remoteStream = remoteStream;
          remoteStream.play(this.$refs.remoteVideo);
        })
        .catch(err => console.error('订阅失败:', err));
    },

    // 处理远端流移除
    handleStreamRemoved(event) {
      if (this.remoteStream && this.remoteStream.getId() === event.stream.getId()) {
        this.remoteStream.close();
        this.remoteStream = null;
      }
    },
  },
  mounted () {
    setTimeout(async ()=>{
      await this.startCall()
    },3000)
  },
  beforeUnmount() {
    this.stopCall();
  },
};
</script>